"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPON_TICKET_CARD_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["code", "discountLabel", "description", "details", "applied", "disabled", "loading", "onApply", "onRemove", "applyText", "removeText", "railWidth", "minHeight", "discountFontSize", "borderRadius", "fontFamily", "displayFontFamily", "colors", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const COUPON_TICKET_CARD_DEFAULTS = exports.COUPON_TICKET_CARD_DEFAULTS = {
  applyText: 'APPLY',
  removeText: 'REMOVE',
  railWidth: 62.541,
  minHeight: 163,
  discountFontSize: 26,
  discountFontSizeCompact: 20,
  discountCompactLength: 9,
  borderRadius: 16,
  fontFamily: 'Inter, sans-serif',
  displayFontFamily: '"Bricolage Grotesque", Inter, sans-serif',
  colors: {
    surface: '#ffffff',
    border: '#f5f2ff',
    divider: '#f2f2f3',
    code: '#100e15',
    text: '#686670',
    discount: 'var(--primary-button, #714fff)',
    apply: 'var(--primary-button, #714fff)',
    remove: '#ef4444',
    railStart: '#ddd4ff',
    railMid: '#ffffff',
    railShadow: 'rgba(207, 200, 255, 0.6)'
  }
};

// Scalloped right edge of the stub — a 3.5px notch every 10px, punched out with a mask.
const NOTCH_RADIUS = 3.5;
const NOTCH_SPACING = 10;
const notchMask = "radial-gradient(circle ".concat(NOTCH_RADIUS, "px at 100% ").concat(NOTCH_SPACING / 2, "px, transparent ").concat(NOTCH_RADIUS, "px, #000 ").concat(NOTCH_RADIUS + 0.1, "px)");
const CouponTicketCard = _ref => {
  let code = _ref.code,
    discountLabel = _ref.discountLabel,
    description = _ref.description,
    details = _ref.details,
    _ref$applied = _ref.applied,
    applied = _ref$applied === void 0 ? false : _ref$applied,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onApply = _ref.onApply,
    onRemove = _ref.onRemove,
    _ref$applyText = _ref.applyText,
    applyText = _ref$applyText === void 0 ? COUPON_TICKET_CARD_DEFAULTS.applyText : _ref$applyText,
    _ref$removeText = _ref.removeText,
    removeText = _ref$removeText === void 0 ? COUPON_TICKET_CARD_DEFAULTS.removeText : _ref$removeText,
    _ref$railWidth = _ref.railWidth,
    railWidth = _ref$railWidth === void 0 ? COUPON_TICKET_CARD_DEFAULTS.railWidth : _ref$railWidth,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? COUPON_TICKET_CARD_DEFAULTS.minHeight : _ref$minHeight,
    discountFontSize = _ref.discountFontSize,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? COUPON_TICKET_CARD_DEFAULTS.borderRadius : _ref$borderRadius,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? COUPON_TICKET_CARD_DEFAULTS.fontFamily : _ref$fontFamily,
    _ref$displayFontFamil = _ref.displayFontFamily,
    displayFontFamily = _ref$displayFontFamil === void 0 ? COUPON_TICKET_CARD_DEFAULTS.displayFontFamily : _ref$displayFontFamil,
    colorsProp = _ref.colors,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  const colors = _objectSpread(_objectSpread({}, COUPON_TICKET_CARD_DEFAULTS.colors), colorsProp);
  const actionDisabled = disabled || loading;
  const railFontSize = discountFontSize !== null && discountFontSize !== void 0 ? discountFontSize : String(discountLabel !== null && discountLabel !== void 0 ? discountLabel : '').length > COUPON_TICKET_CARD_DEFAULTS.discountCompactLength ? COUPON_TICKET_CARD_DEFAULTS.discountFontSizeCompact : COUPON_TICKET_CARD_DEFAULTS.discountFontSize;
  const handleAction = e => {
    if (actionDisabled) return;
    e.stopPropagation();
    if (applied) onRemove === null || onRemove === void 0 || onRemove(code);else onApply === null || onApply === void 0 || onApply(code);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, _objectSpread(_objectSpread({
    sx: _objectSpread({
      display: 'flex',
      alignItems: 'stretch',
      minHeight: "".concat(minHeight, "px"),
      width: '100%',
      boxSizing: 'border-box',
      borderRadius: "".concat(borderRadius, "px"),
      border: "1px solid ".concat(colors.border),
      background: colors.surface,
      boxShadow: '0px 24px 11px -21px rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
      opacity: disabled ? 0.6 : 1,
      fontFamily
    }, sx)
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: {
        flexShrink: 0,
        width: "".concat(railWidth, "px"),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: "linear-gradient(138deg, ".concat(colors.railStart, " 0%, ").concat(colors.railMid, " 52%, ").concat(colors.railStart, " 100%)"),
        boxShadow: "inset -3px 0 3px ".concat(colors.railShadow),
        maskImage: notchMask,
        maskSize: "100% ".concat(NOTCH_SPACING, "px"),
        maskRepeat: 'repeat-y',
        WebkitMaskImage: notchMask,
        WebkitMaskSize: "100% ".concat(NOTCH_SPACING, "px"),
        WebkitMaskRepeat: 'repeat-y'
      },
      children: discountLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        sx: {
          transform: 'rotate(-90deg)',
          whiteSpace: 'nowrap',
          fontFamily: displayFontFamily,
          fontWeight: 700,
          fontSize: "".concat(railFontSize, "px"),
          lineHeight: 1.3,
          textTransform: 'uppercase',
          color: colors.discount,
          m: 0
        },
        children: discountLabel
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        display: 'flex',
        flex: '1 0 0',
        minWidth: 0,
        flexDirection: 'column',
        gap: '12px',
        p: '16px',
        background: colors.surface
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              flex: '1 0 0',
              minWidth: 0,
              fontFamily: displayFontFamily,
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: 1.3,
              textTransform: 'uppercase',
              wordBreak: 'break-word',
              color: colors.code,
              m: 0
            },
            children: code
          }), (onApply || onRemove) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
            disableRipple: true,
            disabled: actionDisabled,
            onClick: handleAction,
            sx: {
              flexShrink: 0,
              minWidth: '39px',
              justifyContent: 'flex-end'
            },
            children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
              size: 14,
              sx: {
                color: applied ? colors.remove : colors.apply
              }
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
              sx: {
                fontFamily,
                fontWeight: 600,
                fontSize: '12px',
                lineHeight: 1.6,
                whiteSpace: 'nowrap',
                color: applied ? colors.remove : colors.apply,
                m: 0
              },
              children: applied ? removeText : applyText
            })
          })]
        }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: 1.3,
            color: colors.text,
            m: 0
          },
          children: description
        })]
      }), details && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
          sx: {
            height: 0,
            borderTop: "1px solid ".concat(colors.divider)
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 500,
            fontSize: '11px',
            lineHeight: 1.5,
            color: colors.text,
            m: 0
          },
          children: details
        })]
      })]
    })]
  }));
};
var _default = exports.default = CouponTicketCard;